var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14 14.666H2a.504.504 0 0 1-.5-.5c0-.273.227-.5.5-.5h12c.273 0 .5.227.5.5 0 .274-.227.5-.5.5zM12.68 2.32c-1.293-1.293-2.56-1.327-3.886 0l-.807.807a.278.278 0 0 0-.067.266 5.42 5.42 0 0 0 3.687 3.687.267.267 0 0 0 .273-.067l.8-.806c.66-.654.98-1.287.98-1.927.007-.66-.313-1.3-.98-1.96z",
    fill: "#1080FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M10.408 7.687a5.864 5.864 0 0 1-.987-.573 4.027 4.027 0 0 1-.373-.287.814.814 0 0 1-.114-.1 5.638 5.638 0 0 1-.686-.694c-.02-.013-.054-.06-.1-.12-.067-.08-.18-.213-.28-.366a3.66 3.66 0 0 1-.26-.394c-.107-.18-.2-.36-.294-.546a7.436 7.436 0 0 1-.233-.574L2.894 8.22a.802.802 0 0 0-.186.367l-.36 2.553c-.067.453.06.88.34 1.166.24.234.573.36.933.36.08 0 .16-.006.24-.02l2.56-.36c.12-.02.287-.1.367-.186l4.186-4.187a9.107 9.107 0 0 1-.566-.226z",
    fill: "#1080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditMore);
export default __webpack_public_path__ + "static/media/editMore.c8da569ec3818c96f9d80cfd2bda56b0.svg";
export { ForwardRef as ReactComponent };